module.exports = __webpack_public_path__ + "static/media/finaleditmobile.24d354fd.jpg";